import {Nullish} from 'utility-types';

import {isNotNil} from 'ramda';

import {CarFeaturesResponseBody} from '@dms/api/core';
import {Key, VehicleTypeEnumObject} from '@dms/api/shared';

import {useVehicleFeaturesV2} from '../../../../../hooks/useVehicleFeaturesV2/useVehicleFeaturesV2';

export function useFeatureAnalysis(
  vehicleType: VehicleTypeEnumObject | Nullish,
  sourcingCarQueryData: CarFeaturesResponseBody | Nullish
) {
  const {flatFeaturesArray} = useVehicleFeaturesV2(vehicleType);

  const premiumItems =
    sourcingCarQueryData?.premiumFeatures
      .map((item) => flatFeaturesArray.find((feature) => feature.const_key === item))
      .filter<Key>(isNotNil)
      .sort((a, b) => a.labels[0].label.localeCompare(b.labels[0].label)) || [];

  const highlightedItems =
    sourcingCarQueryData?.highlightedFeatures
      .map((item) => flatFeaturesArray.find((feature) => feature.const_key === item))
      .filter<Key>(isNotNil)
      .sort((a, b) => a.labels[0].label.localeCompare(b.labels[0].label)) || [];

  return {premiumItems, highlightedItems};
}
